import { useQuery } from '@tanstack/react-query';

import { getTimeContext } from '../api/timeContext';
import { queryKeys } from './queryKeys';

const TIME_CONTEXT_STALE_TIME_MS = 60_000;

export function useTimeContext(enabled = true) {
  return useQuery({
    queryKey: queryKeys.timeContext.current(),
    queryFn: getTimeContext,
    enabled,
    staleTime: TIME_CONTEXT_STALE_TIME_MS,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchInterval: enabled ? TIME_CONTEXT_STALE_TIME_MS : false,
    refetchIntervalInBackground: false,
  });
}
